import localizationEnUsBusinessUnitsHeader from "./en-us/business-units-header.json";
import localizationEnUsBusinessUnitsTable from "./en-us/business-units-table.json";

export const localizationEnUsBusinessUnits = {
  ...localizationEnUsBusinessUnitsHeader,
  ...localizationEnUsBusinessUnitsTable,
};
